import { render } from "./deliveryNavbar.vue?vue&type=template&id=8cacf17e&scoped=true"
import script from "./deliveryNavbar.vue?vue&type=script&lang=js"
export * from "./deliveryNavbar.vue?vue&type=script&lang=js"

import "./deliveryNavbar.vue?vue&type=style&index=0&id=8cacf17e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cacf17e"]])

export default __exports__